import client from "./client";

export default {

    async getExpenseCategories(filters) {
        return client.parseResponse(await client.get('/expense-categories', filters));
    },
    async getExpenseCategory(id) {
        return client.parseResponse(await client.get('/expense-categories/' + id));
    },
    async createExpenseCategory(data) {
        return client.parseResponse(await client.post('/expense-categories', data))
    },
    async editExpenseCategory(data) {
        return client.parseResponse(await client.put('/expense-categories/' + data.id, data))
    },
    async deleteExpenseCategory(data) {
        return client.parseResponse(await client.delete('/expense-categories/' + data.id, data))
    }
}
